<script>
	import API from '../../States/API';
	import Config from '../../Models/Config';
	import Helper from '../../Models/Helper';
	import Session from '../../States/Session';
	import Slider from '../../States/Slider';
	import Trigger from '../../Models/Trigger';
	import Validation from './Password/Validation.svelte';

	export let index = 0;

	let slide = {};
	let pass = {};
	let active = false;
	let pending = false;
	let show_pass = false;

	function showPass() {
		const visible = pass.getAttribute('type') == 'text';
		pass.setAttribute('type', visible ? 'password' : 'text')
		show_pass = !visible;
	}

	async function signUp(event) {
		const data = Helper.form(event.target);
		const response = await API.signUp(data);
		pending = !!response.success;
		if (!pending) {
			const message = Config.labels.sign_up.error;
			Trigger.event('alert', {icon: 'comment-exclamation', message});
		}
	}

	function updateSlider(slides) {
		slide = slides[`slide_${index}`].properties;
		active = slide.active;
	}

	Slider.subscribe(updateSlider);
</script>

<style>
	a.button.proceed {
		text-align: left;
	}

	div.panel {
		display: flex;
		justify-content: space-between;
		margin-bottom: 3em;
	}

	div.panel .button {
		margin-bottom: 0;
	}

	div.panel.sign-up {
		margin-bottom: 1.5em;
	}

	div.panel.sign-up > input,
	div.panel.sign-up > div.group {
		width: calc(25% - .5em);
	}

	div.panel.sign-up > div.group {
		position: relative;
	}

	div.panel.sign-up > div.group i {
		position: absolute;
		top: 1em;
		right: 1em;
		cursor: pointer;
	}

	div.panel.sign-up .button {
		width: calc(25% - .5em);
	}

	@media (max-device-width: 1024px) {
		div.panel {
			flex-direction: column;
		}

		div.panel .button,
		div.panel input,
		div.panel div.group {
			width: 100% !important;
			margin-bottom: .5em;
		}

		div.panel .button {
			padding-top: 1em;
			padding-bottom: 1em;
		}
	}
</style>

<div class="box authentication feature" class:active>
	<div class="menu">
		<div class="begin">
			<div class="title">Registreren</div>
		</div>
		<div class="end">
			<div class="item" on:click="{event => Slider.close()}">
				<i class="fas fa-times"></i>
			</div>
		</div>
	</div>
	<div class="content">
		<h1>Registreren</h1>
		<p>Wil je in de BasisBijbel verzen markeren en/of er aantekeningen bij maken? Registreer dan hieronder jouw eigen BasisBijbel account.</p>
		{#if !pending}
			<h2>Met e-mailadres en wachtwoord.</h2>
			<p>Geef hieronder jouw naam, e-mailadres en wachtwoord op om een account aan te maken.</p>
			<form name="sign_up_form" on:submit|preventDefault="{signUp}">
				<div class="panel sign-up">
					<input type="text" name="name" required="required" placeholder="Naam"/>
					<input type="email" name="mail" required="required" placeholder="E-mailadres"/>
					<div class="group">
						<input bind:this="{pass}" type="password" name="pass" required="required" placeholder="Wachtwoord"/>
						<i on:click="{event => showPass()}" class="fad {show_pass ? 'fa-eye-slash' : 'fa-eye'}"></i>
					</div>
					<button class="button primary solid" type="submit" disabled="{$API.busy}">
						<i class="fad fa-user-plus"></i> Registreren
					</button>
				</div>
			</form>
			<Validation pass="{pass}"/>
		{:else}
			<h2>Bedankt, controleer jouw e-mail berichten.</h2>
			<p>Je ontvangt binnen enkele minuten een e-mail bericht met een link om jouw account te activeren.</p>
			<div class="notice forgotten">
				<i class="fad fa-info-circle"></i> Geen e-mail ontvangen? Controleer dan jouw spam berichten en of je het juiste e-mailadres hebt ingevuld.
			</div>
			<a class="button primary solid proceed" href="/start">
				<i class="fad fa-chevron-right"></i> Verder
			</a>
		{/if}
	</div>
</div>